export interface generateUnitCondsProps {
  val: any;
}
export default function generateUnitConds({ val }: generateUnitCondsProps) {
  if (!val) return [];
  let unitConds: Cond[] = [
    {
      label: <span className="font-bold">{val.unit}</span>,
      title: val.unit,
      value: val.unit,
      min: 0,
      type: "number-native",
    },
  ];
  if (val.subUnit) {
    unitConds.push({
      label: <span className="font-bold">{val.subUnit}</span>,
      title: val.subUnit,
      value: val.subUnit,
      min: 0,
      type: "number-native",
    });
  }
  return unitConds;
}
